// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5830afa0] .avue-crud__menu{display:none}[data-v-5830afa0] .el-table th.is-leaf{padding-left:15px;padding-right:15px}", ""]);
// Exports
module.exports = exports;
